export default __webpack_public_path__ + "media/images/react_icons/login-5781a9122c1b79de2b1b254412af84f0.svg";